import { render, staticRenderFns } from "./FormTotalaLiquidar.vue?vue&type=template&id=5272f938&"
import script from "./FormTotalaLiquidar.vue?vue&type=script&lang=js&"
export * from "./FormTotalaLiquidar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports